import React from 'react';
import { Box, Text } from '@stitch-fix/mode-react';
import styles from './styles.module.scss';
export type SectionsProps = {
  list: {
    title: string;
    id: string;
    isCurrent: boolean;
  }[];
};
export const Sections = ({
  list
}: SectionsProps) => {
  return <Box as="ul" className={styles.sections}>
      {list.map(({
      title,
      id,
      isCurrent
    }) => <Text as="li" setting="body-medium" key={id}>
          {isCurrent ? <strong>{title}</strong> : <>{title}</>}
        </Text>)}
    </Box>;
};